import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import { DashboardListRow } from '../../../DashboardBirdview'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { RentalPortalViewingDateTile } from '../../../RentalPortalViewing'
import { useRentalPortalOverviewLink } from '../RentalPortalOverview.hooks'

import { OverviewViewingText } from './OverviewViewingText'
import {
  QA_NAME_OVERVIEW_VIEWING_ROW,
  QA_NAME_OVERVIEW_VIEWING_ROW_APPLICANT,
  QA_NAME_OVERVIEW_VIEWING_ROW_UNIT,
} from './RentalPortalOverviewViewingRow.constants'
import {
  getOverviewViewingProfileLink,
  getOverviewViewingTimeLabel,
} from './RentalPortalOverviewViewingRow.utils'

import * as styles from './RentalPortalOverviewViewingRow.module.css'

function RentalPortalOverviewViewingRow({ row }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleClickLink: handleOpen, handleMouseDownLink: handleMouseDown } =
    useRentalPortalOverviewLink({ link: getOverviewViewingProfileLink(row) })

  return (
    <DashboardListRow
      Before={RentalPortalViewingDateTile}
      Meta={OverviewViewingText}
      Subtitle={OverviewViewingText}
      beforeProps={{ start: row.scheduled_at }}
      metaProps={{
        className: styles.applicant,
        qaName: QA_NAME_OVERVIEW_VIEWING_ROW_APPLICANT,
        text: row.applicant_display,
      }}
      qaName={QA_NAME_OVERVIEW_VIEWING_ROW}
      subtitleProps={{
        qaName: QA_NAME_OVERVIEW_VIEWING_ROW_UNIT,
        text: getListingUnitLabel({ listing: row, t }),
      }}
      title={getOverviewViewingTimeLabel({
        locale,
        scheduledAt: row.scheduled_at,
        timezone,
      })}
      onMouseDownTitle={handleMouseDown}
      onOpen={handleOpen}
    />
  )
}

export default RentalPortalOverviewViewingRow
